import { useHover } from '@mantine/hooks'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router'
import { Typography } from '../common/typography'
import { Divider } from '@mantine/core'
import classes from './Navigation.module.css'
import { IconSettings } from '@tabler/icons-react'

interface NavigationPage {
  label: string
  link: string
  icon: React.ComponentType<{ className?: string }>
  isCompetition: boolean
  requiredFeature: string | null
}

interface NavigationDesktopProps {
  isAdmin: boolean
  pagesWithCompetitionType: NavigationPage[]
  competition_id: number
}

interface PageProps {
  icon: React.ComponentType<{ className?: string }>
  label: string
  link: string
  location_pathname: string
}

function Page({ icon: Icon, label, link, location_pathname }: PageProps) {
  const isActive = location_pathname
    .toLowerCase()
    .startsWith(link.toLowerCase())

  const { hovered, ref } = useHover()

  const fc =
    hovered || isActive
      ? { light: 'primary-6', dark: 'primary-3' }
      : { light: 'gray-9', dark: 'gray-3' }

  return (
    <>
      <Link to={link} className={classes.linkDesktop}>
        <div ref={ref} className={classes.row}>
          {Icon && (
            <Icon
              className={clsx(
                classes.icon,
                { [classes.active]: isActive },
                { [classes.clairIcon]: label === 'Ask Clair' }
              )}
            />
          )}
          <Typography
            fc={fc}
            hc={{ light: 'primary-6', dark: 'primary-3' }}
            fw={500}
          >
            {label}
          </Typography>
        </div>
      </Link>
      <Divider className={classes.divider} />
    </>
  )
}

export default function NavigationDesktop({
  pagesWithCompetitionType,
  isAdmin,
  competition_id,
}: NavigationDesktopProps) {
  const { pathname } = useLocation()

  const links = pagesWithCompetitionType.map((item) => {
    const adjustedLink = item.isCompetition
      ? `/competitions/${competition_id}${item.link}`
      : item.link

    return (
      <Page
        {...item}
        key={item.label}
        link={adjustedLink}
        location_pathname={pathname}
      />
    )
  })
  return (
    <div className={classes.column}>
      {links}
      {isAdmin && (
        <Page
          icon={IconSettings}
          label="Admin"
          link="/a"
          location_pathname={pathname}
        />
      )}
    </div>
  )
}
